import { createSelector } from "reselect";

const getTags = state => state.data.tags;

const getIdForTag = (state, tag) => state.data.tags.findKey(t => t === tag);

const getTagsArray = createSelector(getTags, tagsMap =>
  tagsMap
    .map((name, id) => {
      return { id, name };
    })
    .toList()
    .toArray()
);

export default { getTags, getIdForTag, getTagsArray };
